<template>
      <v-dialog
          v-model="getLayoutLoading"
          fullscreen
          transition=""
          persistent
          :open-delay="0"
          :close-delay="0"
      >
          <v-layout style="background: #FFFFFF10">
                <v-row>
                    <v-col cols="12" class="align-self-start text-center">
                        <v-progress-linear indeterminate :size="1420" :height="3.5"  :color="getLayoutLoadingColor"></v-progress-linear>
                    </v-col>
                </v-row>
           </v-layout>
      </v-dialog>
</template>

<script>
  export default {
    computed: {
        getLayoutLoading() {
            return this.$store.getters.getLayoutLoading
                || this.$store.getters.getLoading; //it will be removed in the future. it's added for now temporarily
        },
        getLayoutLoadingColor() {
            return this.$store.getters.getLayoutLoadingColor
                || this.$store.getters.getLoadingColor; //it will be removed in the future. it's added for now temporarily
        }
    },
  }
</script>